export class FileUtils {
  static spreadsheetDataURIToBlob = (dataURI: string): Blob => {
    // Split the Data URI into metadata and the Base64 data
    const parts = dataURI.split(',');
    const mimeString = parts[0].split(':')[1].split(';')[0]; // e.g., "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    const base64Data = parts[1];

    // Decode the Base64 string
    const byteCharacters = atob(base64Data);

    // Create an ArrayBuffer and a Uint8Array from the decoded data
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Create the Blob
    return new Blob([byteArray], { type: mimeString });
  };
}
